// pages/Connector/Connectors.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tabs, Tab } from '@mui/material';
import backendURL from "../../config";


export default function Connectors() {
  useEffect(() => {
    document.title = 'Connectors | KlonIT Web Application';
  }, []);

  

  return (
    <div>
      <main className="content">
        <div className="container-fluid p-0">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle"><strong>Connectors </strong> </h1>
          </div>
          <div className="row">
            <div class="col-12 col-md-6 col-lg-3">
							<div class="card">
								<div class="card-header text-center">
                  <img className="img-fluid" src="images/icons/google-drive.png" style={{height: '5em', width: '5em'}} />                  									
								</div>
								<div class="card-body text-center">
                  <h3 class="card-title mb-0">Google Drive</h3>
                  <br/>
									<p class="card-text">Sync you data from Google Drive and connect with chatbot</p>
									<a href="connectors/gdrive" class="btn btn-primary">Configure</a>
								</div>
							</div>
						</div>
            <div class="col-12 col-md-6 col-lg-3">
							<div class="card">
								<div class="card-header text-center">
                  <img className="img-fluid" src="images/icons/google-drive.png" style={{height: '5em', width: '5em'}} />                  									
								</div>
								<div class="card-body text-center">
                  <h3 class="card-title mb-0">One Drive</h3>
                  <br/>
									<p class="card-text">Sync you data from One Drive and connect with chatbot</p>
									<a href="connectors/onedrive" class="btn btn-primary">Configure</a>
								</div>
							</div>
						</div>
          </div>

          
        </div>
      </main>
    </div>
  );
}
